import { defineComponent as _defineComponent } from 'vue';
import { BFormGroup, BFormInput } from "bootstrap-vue";
import { ref, watch } from "vue";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CollectionNameInput',
    props: {
        value: null,
        shortWhatIsBeingCreated: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const name = ref(props.value);
        // Watch for external updates to value and sync with innerValue
        watch(() => props.value, (newValue) => {
            name.value = newValue;
        });
        watch(name, (newValue) => {
            emit("input", newValue);
        });
        return { __sfc: true, props, name, emit, BFormGroup, BFormInput, localize };
    }
});
